








































import {defineComponent} from '@vue/composition-api';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';

export default defineComponent({
  name: 'QueensLabNotebookTask',
  mixins: [DynamicQuestionMixin()],
  components: {StembleLatex},
});
